/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Title_ConversationsInputs */

const en_page_title_conversations = /** @type {(inputs: Page_Title_ConversationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversations`)
};

const nl_page_title_conversations = /** @type {(inputs: Page_Title_ConversationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesprekken`)
};

/**
* | output |
* | --- |
* | "Conversations" |
*
* @param {Page_Title_ConversationsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const page_title_conversations = /** @type {((inputs?: Page_Title_ConversationsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Title_ConversationsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_page_title_conversations(inputs)
	return en_page_title_conversations(inputs)
});